export const GPAC_TEAM = 'gpac';
export const TEAM_COLUMN_NAME = 'name';

export const WIDGETS = {
  mtdProduction: 'mtdProduction',
  mtdTracking: 'mtdTracking',
  ytdProduction: 'ytdProduction',
  ytdTracking: 'ytdTracking'
};
